import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth/authservice';
import { ProfileService } from '../services/profile/profile.service';
import { redirectToLogin } from '../interceptors/auth-expired.interceptor';

export const authGuard: CanActivateFn = async () => {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const auth = inject(AuthService);
  const profile = inject(ProfileService);

  try {
    const session = await auth.ensureSession();

    if (session?.authenticated) {
      void profile.ensureProfile();
      return true;
    }

    profile.clearProfile();
    redirectToLogin();
    return false;
  } catch {
    profile.clearProfile();
    redirectToLogin();
    return false;
  }
};
